import { FormItemTypes } from '@bimser/core';
import { DataGridCellType } from '../../DataGrid/entities';

export function cellTypeToControlType(type: DataGridCellType) {
	switch (type) {
		case DataGridCellType.text:
			return FormItemTypes.EControlTypes.TextBox;
		case DataGridCellType.boolean:
			return FormItemTypes.EControlTypes.Switch;
		case DataGridCellType.actionButton:
			return FormItemTypes.EControlTypes.Button;
		case DataGridCellType.date:
			return FormItemTypes.EControlTypes.DateTimePicker;
		case DataGridCellType.number:
			return FormItemTypes.EControlTypes.NumberBox;
		case DataGridCellType.dateTime:
			return FormItemTypes.EControlTypes.DateTimePicker;
		case DataGridCellType.select:
			return FormItemTypes.EControlTypes.ComboBox;
		case DataGridCellType.time:
			return FormItemTypes.EControlTypes.TimePicker;
	}
}
